import type { ComparisonOffer } from '@entities/mto';
import { fmtDate } from '@entities/mto';
import { Badge } from '@shared/ui/Badge';
import { offerPrice, incomparableHint } from '../helpers';
import { OfferItem, OfferSupplier, OfferPrice, OfferMeta } from '../styles';

export function OfferRow({
  offer,
  group,
  compareCurrency,
  selectable,
  checked,
  onPick,
}: {
  offer: ComparisonOffer;
  /** Имя радиогруппы — одно на строку сравнения. */
  group: string;
  compareCurrency: string | null;
  selectable: boolean;
  checked: boolean;
  onPick: (offerId: string) => void;
}) {
  return (
    <OfferItem
      $dim={!offer.comparable || (offer.expired && !offer.is_min)}
      $selectable={selectable}
    >
      <input
        type="radio"
        name={`offer-${group}`}
        checked={checked}
        disabled={!selectable}
        onChange={() => onPick(offer.offer_id)}
        aria-label={`Выбрать ${offer.supplier_name ?? 'поставщика'} по цене ${offerPrice(offer)}`}
      />
      <OfferSupplier>{offer.supplier_name ?? '— поставщик не указан —'}</OfferSupplier>
      <OfferPrice>{offerPrice(offer)}</OfferPrice>
      <span>
        {offer.is_min && <Badge $tone="success">минимум</Badge>}
        {offer.expired && <Badge $tone="warning">срок КП истёк</Badge>}
        {!offer.comparable && (
          <Badge $tone="neutral">{incomparableHint(offer, compareCurrency)}</Badge>
        )}
      </span>
      <OfferMeta title={offer.source_ref}>
        КП от {fmtDate(offer.created_at)}
        {offer.valid_until ? ` · действует до ${offer.valid_until}` : ''}
      </OfferMeta>
    </OfferItem>
  );
}
